import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface DiscardEditsDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export default function DiscardEditsDialog({
  isOpen,
  setIsOpen,
}: DiscardEditsDialogProps) {
  const isDesktop = useTwBreakpoint("lg");
  const navigate = useNavigate();
  const { search } = useLocation();

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Close = isDesktop ? DialogClose : DrawerClose;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Content>
        <Header
          title="You have unsaved changes"
          subtitle="Are you sure you want to leave?"
        />

        <Footer className="items-center justify-end">
          <Close asChild>
            <Button variant="secondary-black">Cancel</Button>
          </Close>

          <Button
            data-cy="delete-template-button"
            variant="outline-danger"
            onClick={() => navigate({ pathname: "..", search })}
          >
            Discard
          </Button>
        </Footer>
      </Content>
    </Component>
  );
}
